import React from 'react';
import classNames from 'classnames';
class ErrorBoundaryBear extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static wrapper(WrappedComponent, errorProps) {
        return (props) => <ErrorBoundaryBear {...(errorProps || {})}><WrappedComponent {...props}/></ErrorBoundaryBear>;
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        const { errorCallback } = this.props;
        // You can also log the error to an error reporting service
        // Raven.captureException(error, { extra: errorInfo });
        errorCallback && errorCallback(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <NoThingBear {...this.props}/>;
        }
        return this.props.children || [];
    }
}
class NoThingBear extends React.Component {
    render() {
        const { title, tips, style, extra, imgUrl, imgClassName, className } = this.props;
        return (<div className={classNames('cfm_nothing', className)} style={style}>
        <img className={classNames('cfm_nothing_img', imgClassName)} src={imgUrl} alt="bear_logo"/>
        <div className='cfm_nothing_text'>
          {title ? <div className="cfm_nothing_title">{title}</div> : null}
          {tips ? <div className="cfm_nothing_tips">{tips}</div> : null}
        </div>
        {extra ? <div className="cfm_nothing_extra">{extra}</div> : null}
      </div>);
    }
}
NoThingBear.ErrorBoundaryBear = ErrorBoundaryBear;
NoThingBear.defaultProps = {
    title: null,
    tips: null,
    imgUrl: 'https://f.cfcdn.club/assets/4849fbeb77855d6a80fdd6c378aae6cb_400x492.png',
    style: {},
};
export default NoThingBear;



// WEBPACK FOOTER //
// ./components/no-thing-bear/index.tsx